module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/multi-picture-choice-dropdown/multi-picture-choice-dropdown.component.less
// module id = ./src/app/shared/components/multi-picture-choice-dropdown/multi-picture-choice-dropdown.component.less
// module chunks = main